import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Capacitor setup for mobile apps
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Keyboard, KeyboardResize } from '@capacitor/keyboard';

// Initialize Capacitor plugins when running as native app
const initCapacitor = async () => {
  if (Capacitor.isNativePlatform()) {
    console.log('📱 Running as native app on:', Capacitor.getPlatform());
    
    try {
      // Configure Status Bar
      await StatusBar.setStyle({ style: Style.Light });
      await StatusBar.setBackgroundColor({ color: '#ef4444' }); // Red theme color
      
      // Configure Keyboard behavior (iOS)
      if (Capacitor.getPlatform() === 'ios') {
        await Keyboard.setResizeMode({ mode: KeyboardResize.Ionic });
      }
      
      // Hide splash screen after app is ready
      await SplashScreen.hide();
      
      console.log('✅ Capacitor plugins initialized');
    } catch (error) {
      console.log('⚠️ Capacitor plugin init error:', error);
    }
  } else {
    console.log('🌐 Running as web app');
  }
};

initCapacitor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA and offline support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('✅ PWA: Service Worker registered successfully:', registration.scope);
        
        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60000); // Check every minute
        
        // Handle service worker updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker available
              console.log('🔄 New version available! Refresh to update.');
            }
          });
        });
      })
      .catch((error) => {
        console.log('❌ PWA: Service Worker registration failed:', error);
      });
  });
}

console.log('ℹ️ PWA with offline support enabled');
